<div class="gm-page">

  <!-- ── Cabecera ─────────────────────────────────────────── -->
  <div class="gm-header">
    <div class="gm-header__left">
      <div class="gm-header__icon">
        <mat-icon>show_chart</mat-icon>
      </div>
      <div>
        <h1 class="gm-header__title">Margen bruto</h1>
        <p class="gm-header__sub">Informe comercial de ventas y costes · Año {{ yearSelected }}</p>
      </div>
    </div>
  </div>

  <!-- ── Toggle ────────────────────────────────────────────── -->
  <div class="gm-toggle-card">
    <mat-icon>business</mat-icon>
    <span class="gm-toggle-label">Todas las actividades</span>
    <mat-slide-toggle [(ngModel)]="showGlobal" (change)="getData()" color="primary"></mat-slide-toggle>
  </div>

  <!-- ── Loading ───────────────────────────────────────────── -->
  <div class="gm-loading" *ngIf="!resumeloading">
    <div class="gm-loading__icon-wrap"><mat-icon>show_chart</mat-icon></div>
    <div class="gm-loading__dots"><span></span><span></span><span></span></div>
    <p class="gm-loading__text">Calculando margen bruto…</p>
  </div>

  <!-- ── KPI Cards ─────────────────────────────────────────── -->
  <div class="gm-kpi-grid" *ngIf="resumeloading && summaryResult">

    <!-- Total ventas -->
    <div class="gm-kpi gm-kpi--green">
      <div class="gm-kpi__icon-row">
        <div class="gm-kpi__icon"><mat-icon>shopping_cart</mat-icon></div>
        <span class="gm-kpi__label">Total ventas</span>
      </div>
      <div class="gm-kpi__value">
        {{ summaryResult.income | currency:'EUR':'symbol':'1.2-2':'es' }}
      </div>
      <span class="gm-kpi__year">Año {{ yearSelected }}</span>
    </div>

    <!-- Total costes -->
    <div class="gm-kpi gm-kpi--red">
      <div class="gm-kpi__icon-row">
        <div class="gm-kpi__icon"><mat-icon>receipt</mat-icon></div>
        <span class="gm-kpi__label">Total costes</span>
      </div>
      <div class="gm-kpi__value">
        {{ summaryResult.purchases | currency:'EUR':'symbol':'1.2-2':'es' }}
      </div>
      <span class="gm-kpi__year">Año {{ yearSelected }}</span>
    </div>

    <!-- Margen bruto -->
    <div class="gm-kpi gm-kpi--result"
         [style.--gm-kpi-result-color]="summaryResult.grossMargin >= 0 ? '#15803d' : '#dc2626'">
      <div class="gm-kpi__icon-row">
        <div class="gm-kpi__icon"><mat-icon>trending_up</mat-icon></div>
        <span class="gm-kpi__label">Margen bruto</span>
      </div>
      <div class="gm-kpi__value">
        {{ summaryResult.grossMargin | currency:'EUR':'symbol':'1.2-2':'es' }}
      </div>
      <span class="gm-kpi__pct"
            [class.gm-kpi__pct--pos]="summaryResult.grossMargin >= 0"
            [class.gm-kpi__pct--neg]="summaryResult.grossMargin < 0">
        <mat-icon style="font-size:14px;width:14px;height:14px">
          {{ summaryResult.grossMargin >= 0 ? 'arrow_upward' : 'arrow_downward' }}
        </mat-icon>
        {{ getPositivePercentage(summaryResult.grossMargin, summaryResult.income) | percent:'1.0-1' }}
        sobre ventas
      </span>
      <span class="gm-kpi__year">Año {{ yearSelected }}</span>
    </div>

  </div>

</div>
